module.exports = __webpack_public_path__ + "img/logo_site_mob.4ccb70ba.webp";